import {useSelector} from 'react-redux';

import {selectExperienceCalibration} from '@/state/selectors/inference';
import {selectInitialData} from '@/state/selectors/uwm';

const formatMonthDay = (date: Date, languageCode: string): string | undefined => {
    try {
        const formatted = new Intl.DateTimeFormat(languageCode, {month: 'long', day: 'numeric'}).format(date);

        return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    } catch {
        return undefined;
    }
};

const handleExperienceUsageTime = (date: string | undefined, languageCode: string) => {
    if (!date) return undefined;

    try {
        return formatMonthDay(new Date(date.replace(' ', 'T')), languageCode);
    } catch {
        return undefined;
    }
};

const useCalibration = () => {
    const calibration = useSelector(selectExperienceCalibration);
    const initialData = useSelector(selectInitialData);
    const languageCode = initialData?.languageCode ?? 'en';

    const n_sticks_identified = calibration?.n_sticks_identified ?? 0;
    const min_n_experiences_required = calibration?.min_n_experiences_required ?? 0;
    const calibrationPercentage = (n_sticks_identified / min_n_experiences_required) * 100 || 0;
    const isCalibrationActive = n_sticks_identified < min_n_experiences_required;
    const firstUsageTime = handleExperienceUsageTime(calibration?.first_usage_time, languageCode);
    const lastUsageTime = handleExperienceUsageTime(calibration?.last_usage_time, languageCode);

    return {
        isCalibrationActive,
        calibrationPercentage,
        experienceCount: n_sticks_identified,
        experienceThreshold: min_n_experiences_required,
        firstUsageTime,
        lastUsageTime,
    };
};

export default useCalibration;
